<template>
  <div class="page_text_font_box">
    <div class="name">
      <span>{{addressitem.first_name}}</span>
      <span>{{addressitem.last_name}}</span>
    </div>
    <div>
      <span  v-html="email"></span>
    </div>
    <div class="primaryAddress">
      <span>Primary Address</span>
    </div>
    <div >
      <span>{{addressitem.address_1}}</span>
    </div>
    <div>
      <span>{{addressitem.address_2}}</span>
    </div>
    <div>
      <span>{{addressitem.city}}</span>
      <span v-html="province"></span>
      <span>{{addressitem.postcode}}</span>
    </div>
    <div>
      <span v-html="country"></span>
    </div>
    <div>
      <span v-html="addressitem.phone"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["service", "addressitem", "email"],
  data() {
    return {
      country: "",
      province: ""
    };
  },
  mounted() {
    this.service.some(item => {
      if (this.addressitem.country == item.code) {
        this.country = item.name;
        item.states.some(subitem => {
          if (this.addressitem.state == subitem.code) {
            this.province = subitem.name;
            return true;
          }
        });
        return true;
      }
    });
  }
};
</script>
<style scoped lang='scss'>
.page_text_font_box{
  background-color: #F7F7F9;
  padding: 30px 30px;
  div{
    // width: 157px;
    height: 14px;
    font-size: 16px;
    font-family: Roboto;
    font-weight: 400;
    color: #222A40;
    line-height: 42px;
    margin: 10px 0;
  }
  .name{
    // width: 92px;
    height: 14px;
    font-size: 20px;
    font-family: Roboto;
    font-weight: 400;
    color: #222A40;
    line-height: 42px;
    margin: 0 0 20px 0 !important;
  }
  .primaryAddress{
    // width: 146px;
    height: 19px;
    font-size: 20px;
    font-family: Roboto;
    font-weight: 400;
    color: #222A40;
    line-height: 42px;
    margin: 25px 0 20px 0 !important;
  }
}
@media screen and (max-width: 768px) {
  .page_text_font_box{
    padding: 20px 15px !important;
  }
}
</style>